
<div class="page">
    <app-custom-header></app-custom-header>
    <app-sidebar appHoverEffectSidebar></app-sidebar>

    <!-- Start::app-content -->
    <div class="main-content app-content" (click)="clickOnBody()" >
        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>